APP.Header = (/** @lends APP.Header */function () {
	'use strict';

	var exports = {},
		$header,
		stickyTolerance = 10,
		$window,
		$currentSecNav,
		$activePage,
		$secondaryBox,
		secondarySpace,
		$scondaryControllers,
		$secondaryUl,
		$secondaryUlLi,
		secondaryUlSize,
		secondaryLiSize = [],
		secondaryNavActualIndex = 0,
		slidePos = 0,
		$segmentSelector,
		$thirdLevelTrigger,
		$thirdLevelDropdown,
		resizeTimeOut,
		$ctnContainer,
		$ctnListTPL,
		$body;

	function init() {
		initDomElements();
		initBindings();
		initNanoScroller();
		secondaryOpener();
		segmentOpener();
		myMenuOpener();
		headerScroll();
	}

	/**
	 * Init DOM Elements
	 *
	 * @inner
	 * @public
	 * @memberof App.Header
	 * @returns {void}
	 */
	function initDomElements() {
		$body = APP.Performance.getCachedDOM().$body;
		$window = $(window);
		$header = $body.find('.header--default');
		$currentSecNav = $body.find('[data-nav-is-active="true"]');
		$scondaryControllers = $body.find('[data-controller-btn]');
		$segmentSelector = $body.find('[data-segment-selector]');
		$ctnContainer = $body.find('[data-header-accounts]');
		$ctnListTPL = APP.Template.get('mymenu-ctn');
	}

	/**
	 * Init event bindings
	 *
	 * @inner
	 * @public
	 * @returns {void}
	 */
	function initBindings() {
		APP.Bind.click({
			'third-level-toggle': thirdLevelOpener,
			'controller-next': secControlNext,
			'controller-prev': secControlPrev
		});

		$window.on('resize', function () {
			if (resizeTimeOut) {
				window.clearTimeout(resizeTimeOut);
			}

			resizeTimeOut = window.setTimeout(function () {
				getSizeSecHorizontal();
			}, 150);
		});

		$body.on('click', function (e) {
			outsideClose(e);
		});
	}

	function initNanoScroller() {
		var $nanoScrolled = $body.find('.nano');

		$nanoScrolled.nanoScroller({
			preventPageScrolling: true,
			alwaysVisible: true
		});
	}

	function headerScroll() {
		var scrollTimeout,
			scrollAmountOnLoad = $window.scrollTop();

		if (scrollAmountOnLoad >= stickyTolerance) {
			$header.attr('data-header-scrolled', 'true');
		} else {
			$header.attr('data-header-scrolled', 'false');
		}

		$window.on('scroll', function () {
			if (scrollTimeout) {
				window.clearTimeout(scrollTimeout);
			}

			scrollTimeout = window.setTimeout(function () {
				var scrollAmount = $(this).scrollTop();

				if (scrollAmount >= stickyTolerance) {
					$header.attr('data-header-scrolled', 'true');
				} else {
					$header.attr('data-header-scrolled', 'false');
				}
			}, 250);
		});
	}

	function getSizeSecHorizontal() {
		$currentSecNav = $body.find('[data-nav-is-active="true"]');
		$activePage = $currentSecNav.find('.navigation-secondary__list .nav-link--active');
		$secondaryBox = $currentSecNav.find('.secondary-box');

		$secondaryUl = $currentSecNav.find('[data-secondary-ul]');
		$secondaryUlLi = $currentSecNav.find('[data-secondary-ul] > li');
		secondarySpace = $secondaryBox.width();

		secondaryUlSize = 0;

		$secondaryUlLi.each(function () {
			var $this = $(this);

			secondaryUlSize += $this.outerWidth(true);
			secondaryLiSize.push($this.outerWidth(true));
		});
		secondarySteps();
	}

	function secondarySteps() {
		slidePos = secondaryUlSize - secondarySpace;

		if (secondaryUlSize > secondarySpace) {
			secondaryNavActualIndex = 0;
			$secondaryBox.addClass('block--overflow-hidden');
			if ($activePage.length) {
				secondaryNavActualIndex = $activePage.parent().index();
			}
			secControlGoTo(secondaryNavActualIndex);
		} else {
			$scondaryControllers.removeClass('active');
			$secondaryBox.removeClass('block--overflow-hidden');
		}
	}

	function secControlNext() {
		if (secondaryNavActualIndex < secondaryLiSize.length - 1) {
			secControlGoTo(++secondaryNavActualIndex);
		}
	}

	function secControlPrev() {
		if (secondaryNavActualIndex >= 0) {
			secControlGoTo(--secondaryNavActualIndex);
		}
	}

	function secControlGoTo(index) {
		var $prev = $body.find('[data-click="controller-prev"]'),
			$next = $body.find('[data-click="controller-next"]'),
			left = 0,
			i;

		for (i = 0; i < index; i++) {
			left += secondaryLiSize[i];
		}

		$secondaryUl.animate({left: -left}, 400);

		if (index === 0) {
			$prev.removeClass('active');
		} else {
			$prev.addClass('active');
		}

		if (left > slidePos) {
			$next.removeClass('active');
		} else {
			$next.addClass('active');
		}
	}

	function secondaryOpener() {
		var $secNavTrigger = $body.find('[data-second-level-nav]');

		if ($body.find('[data-nav-is-active="true"]').length > 0) {
			$header.attr('data-secondary-nav', 'active');
		}

		$secNavTrigger.on('click', function () {
			var navNumber = $(this).attr('data-second-level-nav'),
				$secLevelNav = $body.find('#secondary-nav-' + navNumber),
				$currentNav = $body.find('[data-nav-is-active="true"]'),
				$currentTrigger = $body.find('[data-second-level-nav=' + navNumber + ']'),
				$generalTriggers = $currentTrigger.parent().siblings(),
				$thirdLevelMenu = $body.find('.dropdown-menu__box'),
				$thirdLevelTrigger = $currentNav.find('[data-has-dropdown="true"]');

			$currentNav.attr('data-nav-is-active', 'false');
			$thirdLevelMenu.attr('data-dropdown-menu', 'false');
			$thirdLevelTrigger.removeClass('nav-link--active');

			if ($secLevelNav.attr('data-nav-is-active') === 'false') {
				$secLevelNav.attr('data-nav-is-active', 'true');
				$header.attr('data-secondary-nav', 'active');
				$currentTrigger.parent().attr('data-active-state', 'true');
				$generalTriggers.attr('data-active-state', 'false');
				getSizeSecHorizontal();
			}
		});
	}

	function segmentOpener() {
		var $segmentTrigger = $body.find('[data-segment-toggle]');

		$segmentTrigger.on('click', function () {

			if ($segmentSelector.attr('data-segment-selector') === 'false') {
				$segmentSelector.attr('data-segment-selector', 'true');
				$(this).parent().attr('data-segment-active', 'true');
			} else {
				$segmentSelector.attr('data-segment-selector', 'false');
				$(this).parent().attr('data-segment-active', 'false');
			}
		});
	}

	function myMenuOpener() {
		var $myMenuTrigger = $body.find('[data-login-toggle]'),
			$header = $body.find('.header--mobile'),
			$myMenu = $body.find('[data-mymenu-dropdown]'),
			$helpTrigger = $myMenu.find('[data-mymenu-help-toggle]'),
			$helpBox = $myMenu.find('[data-mymenu-help]');

		$myMenuTrigger.on('click', function () {
			var $this = $(this);

			if ($myMenu.attr('data-mymenu-dropdown') === 'hide') {
				$myMenu.attr('data-mymenu-dropdown', 'show');
				$this.attr('data-mymenu-active', 'true');
				$header.addClass('menu-open');
			} else {
				$myMenu.attr('data-mymenu-dropdown', 'hide');
				$this.attr('data-mymenu-active', 'false');
				setTimeout(function(){
					$header.removeClass('menu-open');
				}, 300);
			}
		});

		$helpTrigger.on('click', function () {
			if ($helpBox.attr('data-mymenu-help') === 'show') {
				$helpBox.attr('data-mymenu-help', 'hide');
			}
		});
	}

	function thirdLevelOpener(event) {
		var opened;

		$currentSecNav = $body.find('[data-nav-is-active="true"]');
		$thirdLevelTrigger = $(event.target);
		$thirdLevelDropdown = $(event.target.nextElementSibling);
		opened = $thirdLevelDropdown.attr('data-dropdown-menu') === 'true';

		$body.find('[data-dropdown-menu]').attr('data-dropdown-menu', 'false');
		$body.find('[data-has-dropdown="true"]').removeClass('nav-link--active');
		$body.find('.secondary-box').css('height', '50px');

		if (!opened) {
			$thirdLevelDropdown.attr('data-dropdown-menu', 'true');
			$thirdLevelTrigger.addClass('nav-link--active');
			$currentSecNav.find('.secondary-box').css('height', '600px');
			getSizeSecHorizontal();
		}
	}

	function updateCtnList() {
		APP.Service.get({}, '/api/v1/main/user')
			.done(function (result) {
				$ctnContainer.empty();
				$ctnContainer.html($ctnListTPL(result));


				if(result.data.user.assignedCustomers.length) {
					$('[data-mymenu-dropdown-ctnlist]').removeClass('mymenu-dropdown__content--no-ctn');
				} else {
					$('[data-mymenu-dropdown-ctnlist]').addClass('mymenu-dropdown__content--no-ctn');
				}

				initNanoScroller();
			});
	}

	function outsideClose(e) {
		var $segmentSelectorNarrow = $body.find('.segment-selector--narrow'),
			$header = $body.find('header--mobile'),
			$myMenuTrigger = $body.find('[data-login-toggle]'),
			$myMenu = $body.find('[data-mymenu-dropdown]'),
			$subMenu = $body.find('[data-dropdown-menu="true"]').parent();

		if (!$subMenu.is(e.target) && $subMenu.has(e.target).length === 0) {
			$subMenu.find('[data-dropdown-menu]').attr('data-dropdown-menu', 'false');
			$subMenu.find('[data-has-dropdown="true"]').removeClass('nav-link--active');
			setTimeout(function () {
				$body.find('.secondary-box').css('height', '50px');
			}, 601);
		}

		if ($segmentSelector.attr('data-segment-selector') === 'true') {
			if (!$segmentSelectorNarrow.is(e.target) && $segmentSelectorNarrow.has(e.target).length === 0) {
				$segmentSelector.attr('data-segment-selector', 'false');
				$segmentSelectorNarrow.attr('data-segment-active', 'false');
			}
		}

		if ($myMenu.attr('data-mymenu-dropdown') === 'show') {
			if (!$myMenuTrigger.is(e.target) && $myMenuTrigger.has(e.target).length === 0 && !$myMenu.is(e.target) && $myMenu.has(e.target).length === 0) {
				$myMenu.attr('data-mymenu-dropdown', 'hide');
				$myMenuTrigger.attr('data-mymenu-active', 'false');
				setTimeout(function(){
					$header.removeClass('menu-open');
				}, 300);
			}
		}
	}

	exports.init = init;
	exports.updateCtnList = updateCtnList;
	return exports;

}());

